import { AutocompleteRecord } from '../interfaces';
import { getRecord } from './universal';

export const IDENTITIES_KEY = 'IDENTITIES_KEY';

export interface Identity {
  id: number;
  followedEntities: AutocompleteRecord[];
}

export async function getIdentity(id: number): Promise<Identity> {
  const resp = await getRecord({
    id,
    model: 'Identity',
    attributes: ['id'],
    helpers: ['followedEntities'],
  });
  return resp.result;
}
